import React from "react";
import CatalogoPageLayout from "./CatalogoPageLayout";

const CatalogoComprobantesPage: React.FC = () => (
  <CatalogoPageLayout
    title="Timbrados y comprobantes"
    description="Administrá tipos de comprobante, talonarios y timbrados autorizados por la SET."
    helperText="Muy pronto vas a poder cargar numeraciones, vigencias y asociarlas a sucursales."
  />
);

export default CatalogoComprobantesPage;
